import React from "react";
import styled from "styled-components";
import { Container } from "react-bootstrap";
import UnderlinedHeader from "../../molecules/UnderlinedHeader/UnderlinedHeader";

const Warranties = () => (
  <StyledWarranties>
    <Container>
      <UnderlinedHeader text={"Warranties"} bolder />
      <ol>
        <li>
          <p>
            Each sale of goods shall be subject to the standard warranty of
            Pedders in force from time to time.
          </p>
          <p>
            Pedders warrant the quality and condition of all products
            distributed by Pedders bearing the brand name of Pedders for a
            period of twenty four (24) months from the date of the invoice or
            until such time as the subject vehicle has traveled 40,000
            kilometers from the date of installation of the subject goods,
            whichever occurs first.
          </p>
          <p>
            If any goods supplied by Pedders are found upon examination by a
            Pedders representative to be defective in material or workmanship
            and if the goods have not been damaged by misuse, improper
            installation or operation, lack of maintenance or other cause beyond
            the control of Pedders the goods will be replaced or repaired by
            Pedders or Pedders will credit the Purchaser upon delivery prepaid
            of the goods to the warehouse or depot from which they were
            purchased. The cost of removal and/or installation of goods pursuant
            to the paragraph (c) is not covered by the standard warranty.
          </p>
          <p>
            Pedders will not be liable for any damage caused by any goods to any
            vehicle or other component if in Pedders opinion the goods were
            incorrectly fitted by the Purchaser or the goods have been applied
            for a purpose for which the goods were not manufactured.
          </p>
        </li>
        <li>
          <p>
            All conditions, warranties, representations, liabilities and
            obligations whether implied or imposed by statute or otherwise in
            respect of the supply of goods including any conditions or
            warranties as to merchantability fitness for purpose or
            correspondence with description are hereby excluded:
          </p>
          <p>
            All liability for loss or damage whether consequential or otherwise
            and whether arising from negligence or from any other cause
            whatsoever is hereby excluded.
          </p>
        </li>
        <a
          href={"https://ozparts.eu/warranty/PEDDERS/"}
          target="_blank"
          rel="noopener noreferrer"
        >
          <StyledButton>Warranty Form</StyledButton>
        </a>
      </ol>
    </Container>
  </StyledWarranties>
);

export default Warranties;

const StyledWarranties = styled.section`
  padding-top: 92px;
  color: #666666;
  font-size: 14px;
  font-family: "Open Sans", sans-serif;
`;

const StyledButton = styled.button`
  border: none;
  padding: 10px;
  border-radius: 4px;
  color: #fff;
  background-color: #dc3332;
  font-size: 14px;
  font-weight: 600;
  margin: 20px 0;
  font-family: "Open Sans", sans-serif;
`;
